import React from "react"
import PropTypes from "prop-types"
import { Stack } from "@mantine/core"

import { LegislationSummary, StatusBar } from "quorumdesign"
import { SummarySectionWithPersonalizedTab } from "app/static/frontend/profiles-new/components/BillSummary/SummarySectionWithPersonalizedTab"
import ChevronTimeline from "app/static/frontend/components/ChevronTimeline"

const BillSummary = ({
    aiSummaryText,
    aiSummaryDate,
    aiSummarySingleSentence,
    personalizedSummaryText,
    profileId,
    statusBarLabels,
    statusBarNumberCompleted,
    sessionEndDate,
    sessionStartDate,
    statusDate,
    statusText,
    summaryText,
    billId,
    boardId,
    dataType,
    nextBillId,
    mostRecentBillText,
    chevronSteps,
}) => {
    return (
        <Stack spacing="md">
            {(summaryText || aiSummaryText || personalizedSummaryText) && (
                <SummarySectionWithPersonalizedTab
                    aiSummary={aiSummaryText}
                    aiSummaryDate={aiSummaryDate}
                    aiSummarySingleSentence={aiSummarySingleSentence}
                    personalizedSummary={personalizedSummaryText}
                    profileId={profileId}
                    billId={billId}
                    boardId={boardId}
                    nextBillId={nextBillId}
                    officialSummary={summaryText}
                    mostRecentBillText={mostRecentBillText}
                    isBillDataType={dataType === "bill"}
                />
            )}
            {(statusText || statusDate || sessionStartDate || sessionEndDate) && (
                <LegislationSummary
                    statusText={statusText}
                    statusDate={statusDate}
                    sessionStartDate={sessionStartDate}
                    sessionEndDate={sessionEndDate}
                />
            )}
            {chevronSteps && <ChevronTimeline steps={chevronSteps} />}
            {statusBarLabels && <StatusBar labels={statusBarLabels} numCompleted={statusBarNumberCompleted} />}
        </Stack>
    )
}

BillSummary.propTypes = {
    aiSummaryText: PropTypes.string,
    aiSummarySingleSentence: PropTypes.string,
    personalizedSummaryText: PropTypes.string,
    // array of labels, one for each notch on the status bar
    statusBarLabels: PropTypes.array,
    // integer number of steps to fill in from left to right
    statusBarNumberCompleted: PropTypes.number,
    // session and status dates and text to display in the summary
    sessionEndDate: PropTypes.string,
    sessionStartDate: PropTypes.string,
    statusDate: PropTypes.string,
    statusText: PropTypes.string,
    summaryText: PropTypes.string,
    dataType: PropTypes.string,
    mostRecentBillText: PropTypes.object,
    // array of chevron timeline steps (for new timeline feature)
    chevronSteps: PropTypes.array,
}

export default BillSummary
